<div class="admin containerView">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
            <li>
              <a routerLink="/license/new">
                Solicitar
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div style="width: 100%;">
        <app-license-detail [requirementId]="id" [personId]="userId" [shouldShowPersonalData]='true'
          [shouldShowDocumentLinks]="true" (goBack)="goBack()">
        </app-license-detail>
      </div>
    </div>
  </div>
</div>
